import { createFileRoute, Link } from '@tanstack/react-router';
import { Button, Wordmark } from '@glob/ui';
import { GlobVector } from '@glob/glob';
import { useT } from '../../i18n';

function PublicLanding() {
  const t = useT();
  return (
    <main className="mx-auto max-w-md space-y-6 p-8">
      <header className="flex items-start gap-4">
        <GlobVector mood="blink" size={64} title="Glob" />
        <div className="space-y-2">
          <Wordmark size={26} />
          <p className="text-sm text-text-2">{t('public.tagline')}</p>
        </div>
      </header>
      <div className="flex flex-wrap items-center gap-3">
        <Link to="/unlock">
          <Button variant="primary" size="lg">
            {t('public.unlock')}
          </Button>
        </Link>
        <Link to="/register">
          <Button variant="secondary" size="lg">
            {t('public.create-account')}
          </Button>
        </Link>
        <Link to="/security" className="self-center text-sm text-text-3 underline">
          {t('public.security-details')}
        </Link>
      </div>
    </main>
  );
}

export const Route = createFileRoute('/_public/')({
  component: PublicLanding,
});
